import { render, staticRenderFns } from "./HandicapGameData.vue?vue&type=template&id=1c8e5317&scoped=true"
import script from "./HandicapGameData.vue?vue&type=script&lang=js"
export * from "./HandicapGameData.vue?vue&type=script&lang=js"
import style0 from "./HandicapGameData.vue?vue&type=style&index=0&id=1c8e5317&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8e5317",
  null
  
)

export default component.exports